import { Instagram, Mail, FileText } from "lucide-react";
import { Logo } from "./Nav";
import { RULES_PDF_URL, INSTAGRAM_URL, CONTACT_EMAIL } from "../lib/scroll";

const linkCls = "link-underline inline-flex items-center gap-2 font-body text-lg font-semibold text-paper";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-paper">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 lg:px-10">
      <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <Logo testId="footer-logo" />
          <p className="mt-4 max-w-xs font-body text-base text-paper/85">2 Minute Film Awards. Make us feel something.</p>
        </div>
        <ul className="flex flex-col gap-4">
          <li><a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-email" className={linkCls}><Mail size={18} /> Contact {CONTACT_EMAIL}</a></li>
          <li><a href={RULES_PDF_URL} data-testid="footer-rules-pdf" className={linkCls}><FileText size={18} /> Rules Sheet (PDF)</a></li>
          <li><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className={linkCls}><Instagram size={18} /> @convey.awards</a></li>
        </ul>
      </div>
      <p data-testid="footer-disclaimer" className="mt-14 border-t border-white/15 pt-6 font-body text-sm text-paper/80">Not endorsed by Instagram or Meta.</p>
    </div>
  </footer>
);
